export default "__VITE_ASSET__DZcOllv8__"